import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomButton = styled(Button)(({ theme }) => ({
  width: '120px',
  maxHeight: '36.5px',
  fontWeight: '400',
  fontSize: '1.2rem',
  borderRadius: '20px',
  color: theme.palette.primary.title,

  '&:hover': {
    backgroundColor: theme.palette.primary.titleShadow,
  },
}));
